"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationPaperCompleted = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 454 230",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
        id: "path-1",
        points: "0 206.000003 310.176005 206.000003 310.176005 0.366800005 0 0.366800005"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1.17120002,0.304400005 C0.66880001,0.304400005 0.261600004,0.712000011 0.261600004,1.21400002 L0.261600004,1.21400002 L0.261600004,54.3356008 C0.261600004,61.6172009 5.73800009,67.619601 12.7968002,68.447601 L12.7968002,68.447601 L55.9668008,68.447601 C63.0256009,67.619601 68.502001,61.6172009 68.502001,54.3356008 L68.502001,54.3356008 L68.502001,1.21400002 C68.502001,0.712000011 68.094801,0.304400005 67.592401,0.304400005 L67.592401,0.304400005 L1.17120002,0.304400005 Z",
        id: "path-3"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1.17120002,0.304400005 C0.66880001,0.304400005 0.261600004,0.712000011 0.261600004,1.21400002 L0.261600004,1.21400002 L0.261600004,54.3356008 C0.261600004,61.6172009 5.73800009,67.619601 12.7968002,68.447601 L12.7968002,68.447601 L36.9224006,68.447601 C43.9816007,67.619601 49.4584007,61.6172009 49.4584007,54.3356008 L49.4584007,54.3356008 L49.4584007,1.21400002 C49.4584007,0.712000011 49.0512007,0.304400005 48.5488007,0.304400005 L48.5488007,0.304400005 L1.17120002,0.304400005 Z",
        id: "path-5"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
        id: "path-7",
        points: "0.261600004 0.0548000008 68.501601 0.0548000008 68.501601 9.80560015 0.261600004 9.80560015"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
        id: "path-9",
        points: "0.214000003 0.0548000008 19.7148003 0.0548000008 19.7148003 9.80560015 0.214000003 9.80560015"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0.114800002,9.80560015 C5.50000008,9.80560015 9.86520015,14.1712002 9.86520015,19.5560003 L9.86520015,19.5560003 C9.86520015,24.9412004 5.50000008,29.3064004 0.114800002,29.3064004 L0.114800002,29.3064004 L0.114800002,39.0568006 C10.8848002,39.0568006 19.6156003,30.3260005 19.6156003,19.5560003 L19.6156003,19.5560003 C19.6156003,8.78600013 10.8848002,0.0556000008 0.114800002,0.0556000008 L0.114800002,0.0556000008 L0.114800002,9.80560015 Z",
        id: "path-11"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-493.000000, -397.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          id: "Group-3",
          transform: "translate(493.000000, 397.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            id: "Group-Copy-3",
            transform: "translate(56.000000, 0.000000)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "Group-2",
              transform: "translate(0.800001, 0.000000)",
              className: "fill-primary",
              fill: "#E6EDFB",
              fillRule: "nonzero",
              opacity: "0.1",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M197.315586,37.6581865 C175.544548,36.9005305 154.807364,29.8369356 135.007861,22.1100233 C115.208357,14.383111 95.592183,5.81894452 74.3440824,1.72406424 C60.6755731,-0.908569371 45.0445446,-1.28002719 34.0327991,6.08132346 C23.4327919,13.1567106 20.0096538,25.4030264 18.1703556,36.7413342 C16.7848714,45.2907603 15.9704109,54.2676577 19.7632119,62.2628451 C22.398938,67.8140759 27.0783288,72.4779352 30.3151328,77.7933197 C41.5703149,96.2925089 33.6210607,119.104736 21.4131705,137.16761 C15.7029313,145.640386 9.05200525,153.724015 4.63708879,162.742186 C0.222172181,171.760357 -1.82149233,182.096318 2.04043265,191.297269 C5.87230362,200.418622 14.9966649,207.267007 24.8813894,212.084167 C44.9603936,221.871786 68.6218217,224.67246 91.6941934,226.258525 C142.767775,229.769686 194.114847,228.248479 245.323672,226.72727 C264.275654,226.161239 283.308783,225.59226 301.954217,222.647131 C312.304777,221.010947 322.99194,218.416638 330.505412,212.149025 C340.047523,204.189214 342.412764,190.725342 336.017297,180.751995 C325.303084,164.027548 295.648911,159.876655 288.153471,141.916964 C284.027072,132.035006 288.26467,121.026883 294.260421,111.846568 C307.123487,92.1858363 328.684146,74.9366322 329.820185,52.4604859 C330.601585,37.0243497 320.235998,21.5646289 304.211264,14.2622398 C287.41114,6.5972371 264.119374,7.57010284 251.72515,20.2409418 C238.964268,33.3097715 216.538055,38.3303483 197.315586,37.6581865 Z",
                id: "Path"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "Group-41",
              transform: "translate(0.800001, 20.000000)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-25",
                transform: "translate(0.000000, 0.033200)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M224.000003,67.790121 L224.000003,186.190123 C224.000003,195.026923 231.163203,202.190123 240.000003,202.190123 C248.836804,202.190123 256.000003,195.026923 256.000003,186.190123 L256.000003,67.790121 L224.000003,67.790121 Z",
                  id: "Fill-1",
                  className: "fill-dark-primary",
                  fill: "#1145B4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                  id: "mask-2",
                  fill: "white",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-1"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  id: "Clip-4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-3",
                  className: "fill-dark-primary",
                  fill: "#1145B4",
                  mask: "url(#mask-2)",
                  points: "83.2000012 71.7900011 256.000004 71.7900011 256.000004 48.5900007 83.2000012 48.5900007"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-5",
                  className: "fill-primary20",
                  fill: "#C3D4F7",
                  mask: "url(#mask-2)",
                  points: "124.800002 170.190003 243.200004 170.190003 243.200004 0.366800005 124.800002 0.366800005"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M224.000001,186.190123 L224.000001,67.790121 L96.000001,67.790121 L80.000001,67.790121 L64.000001,67.790121 L64.000001,186.190123 C64.000001,195.026923 71.1636011,202.190123 80.000001,202.190123 L240.000001,202.190123 C231.163203,202.190123 224.000001,195.026923 224.000001,186.190123",
                  id: "Fill-6",
                  className: "fill-primary-opa50",
                  fill: "#88A9F0",
                  mask: "url(#mask-2)"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-7",
                  className: "fill-primary",
                  fill: "#1657E2",
                  mask: "url(#mask-2)",
                  points: "92.8000014 189.390003 211.200003 189.390003 211.200003 32.5900005 92.8000014 32.5900005"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-8",
                  className: "fill-primary40",
                  fill: "#88A9F0",
                  mask: "url(#mask-2)",
                  points: "92.8000014 67.790001 211.200003 67.790001 211.200003 32.5900005 92.8000014 32.5900005"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-9",
                  fill: "#FFFFFF",
                  mask: "url(#mask-2)",
                  points: "83.2000012 189.613603 201.600003 189.613603 201.600003 19.7900003 83.2000012 19.7900003"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M99.2000015,51.7900008 L140.800002,51.7900008 L140.800002,42.1900006 L99.2000015,42.1900006 L99.2000015,51.7900008 Z",
                  id: "Fill-18",
                  fill: "#C3D0D8",
                  mask: "url(#mask-2)"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M99.2000015,67.790001 L140.800002,67.790001 L140.800002,58.1900009 L99.2000015,58.1900009 L99.2000015,67.790001 Z",
                  id: "Fill-19",
                  fill: "#C3D0D8",
                  mask: "url(#mask-2)"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M99.2000015,112.990002 L182.400003,112.990002 L182.400003,103.390002 L99.2000015,103.390002 L99.2000015,112.990002 Z",
                  id: "Fill-20",
                  fill: "#C3D0D8",
                  mask: "url(#mask-2)"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M99.2000015,96.9900015 L182.400003,96.9900015 L182.400003,87.3900014 L99.2000015,87.3900014 L99.2000015,96.9900015 Z",
                  id: "Fill-21",
                  fill: "#C3D0D8",
                  mask: "url(#mask-2)"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M99.2000015,128.990002 L131.200001,128.990002 L131.200001,119.390002 L99.2000015,119.390002 L99.2000015,128.990002 Z",
                  id: "Fill-22",
                  fill: "#C3D0D8",
                  mask: "url(#mask-2)"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M99.2000015,144.990002 L131.200001,144.990002 L131.200001,135.390002 L99.2000015,135.390002 L99.2000015,144.990002 Z",
                  id: "Fill-23",
                  fill: "#C3D0D8",
                  mask: "url(#mask-2)"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-28",
                transform: "translate(219.200003, 134.033202)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                  id: "mask-4",
                  fill: "white",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-3"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  id: "Clip-27"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-26",
                  fill: "#C3D0D8",
                  mask: "url(#mask-4)",
                  points: "-2.69880004 71.5056011 71.4624011 71.5056011 71.4624011 -2.65560004 -2.69880004 -2.65560004"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-31",
                transform: "translate(219.200003, 134.033202)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                  id: "mask-6",
                  fill: "white",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-5"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  id: "Clip-30"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-29",
                  fill: "#FFFFFF",
                  mask: "url(#mask-6)",
                  points: "-21.7424003 71.5056011 52.4188008 71.5056011 52.4188008 -2.65560004 -21.7424003 -2.65560004"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-34",
                transform: "translate(219.200003, 144.033202)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                  id: "mask-8",
                  fill: "white",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-7"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  id: "Clip-33"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-32",
                  fill: "#091E43",
                  mask: "url(#mask-8)",
                  points: "-2.69880004 12.7660002 71.4624011 12.7660002 71.4624011 -2.90520004 -2.69880004 -2.90520004"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-37",
                transform: "translate(268.000004, 144.033202)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                  id: "mask-10",
                  fill: "white",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-9"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  id: "Clip-36"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-35",
                  fill: "#091E43",
                  mask: "url(#mask-10)",
                  points: "-2.74640004 12.7660002 22.6752003 12.7660002 22.6752003 -2.90520004 -2.74640004 -2.90520004"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-40",
                transform: "translate(287.600004, 144.033202)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                  id: "mask-12",
                  fill: "white",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-11"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  id: "Clip-39"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Fill-38",
                  fill: "#C3D0D8",
                  mask: "url(#mask-12)",
                  points: "-2.84560004 42.0176006 22.5764003 42.0176006 22.5764003 -2.90520004 -2.84560004 -2.90520004"
                })]
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            id: "Rectangle-Copy-3",
            fill: "#10105A",
            fillRule: "nonzero",
            x: "0",
            y: "222.000003",
            width: "453.600007",
            height: "7.20000011",
            rx: "3.60000005"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            id: "Rectangle-Copy-39",
            stroke: "#C3D0D8",
            strokeWidth: "4.94999993",
            points: "198 141.627849 237 141.627849 237 180.627849 198 180.627849"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            id: "Path-3",
            fill: "#1C895D",
            fillRule: "nonzero",
            points: "241.574539 140 247 146.351416 216.239802 173 203 155.537288 209.61228 150.452885 217.499381 160.857038"
          })]
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationPaperCompleted')(IllustrationPaperCompleted);